import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

var database = null;

try {
  var databaseURL = process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://mvplab-screens-default-rtdb.europe-west1.firebasedatabase.app";

  var firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD_YxdRsLYJUdv4SLnckqIhourZWZl_aLQ",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "mvplab-screens.firebaseapp.com",
    databaseURL: databaseURL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "mvplab-screens",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "mvplab-screens.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "964610465251",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:964610465251:web:e131eb2b58b325a35814d6"
  };

  var app = initializeApp(firebaseConfig);
  database = getDatabase(app);
} catch (e) {
  console.warn("Firebase init failed, using localStorage only:", e.message);
}

export { database };
